import React from "react";
import { required, number, DisabledInput, NumberInput } from "react-admin";
import {isAdmin} from "./../../services/LocalStorage";

const validateCoreShopId = [required(), number()];

// Get saved core shop id if set
const coreShopId = localStorage.getItem("coreShopId");

// Field props
const coreShopFieldProps = {
  source: "coreShopId",
  label: "Core shop ID",
  defaultValue: coreShopId ? parseInt(coreShopId) : "",
  validate: validateCoreShopId
};

class CoreShopField extends React.Component {
  render() {
    return (
      isAdmin() ? (
        <NumberInput {...coreShopFieldProps}/>
      ) : (
        <DisabledInput {...coreShopFieldProps}/>
      )
    );
  }
}

export default CoreShopField;
